export default "__VITE_ASSET__DaDq3ppl__"